import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { FEATURES } from '../config/features';

/**
 * Whether ads should currently be shown, combining the build-time
 * FEATURES.ADS_ENABLED kill switch with the live appConfig/global.showAds
 * flag a superadmin can toggle from the admin panel. FEATURES.ADS_ENABLED
 * is checked first and short-circuits to false without touching Firestore -
 * it's the hard, redeploy-required override; the Firestore flag is the
 * normal day-to-day control.
 */
export function useShowAds(): boolean {
  const [showAds, setShowAds] = useState(FEATURES.ADS_ENABLED);

  useEffect(() => {
    if (!FEATURES.ADS_ENABLED) return;

    const unsubscribe = onSnapshot(
      doc(db, 'appConfig', 'global'),
      (snap) => {
        const data = snap.data();
        if (typeof data?.showAds === 'boolean') {
          setShowAds(data.showAds);
        }
      },
      (error) => {
        console.warn('[useShowAds] Failed to read appConfig/global:', error.message);
      },
    );

    return unsubscribe;
  }, []);

  return showAds;
}
